import React from 'react'
import '../styles/Return.css'

function Return() {
  return (
    <div className="rp-page">
      <div className="rp-container">

        <div className="rp-header">
          <p className="rp-eyebrow">yourhood.ge</p>
          <h1 className="rp-title">დაბრუნების პოლიტიკა</h1>
          <div className="rp-divider" />
        </div>

        <div className="rp-intro">
          <p>
            მომხმარებელი უფლებამოსილია უკან დააბრუნოს yourhood.ge-ზე შეძენილი ნივთი,
            თუ სახეზეა ამ პუნქტით გათვალისწინებული წინაპირობები, ხოლო სანაცვლოდ
            საკუთარი არჩევანით — დაიბრუნოს გადახდილი თანხა ან მიიღოს ახალი პროდუქტი.
          </p>
        </div>

        <div className="rp-section">
          <h2 className="rp-section-title">მიწოდების ვადის დარღვევა</h2>
          <p className="rp-section-text">
            თუ შეძენილი პროდუქტის მიწოდება მოხდა ვებ-გვერდზე მითითებული მიწოდების ვადის დარღვევით,
            მომხმარებელი უფლებამოსილია უარი თქვას მის მიღებაზე და აღნიშნული დააფიქსიროს კურიერთან.
          </p>
        </div>

        <div className="rp-section">
          <h2 className="rp-section-title">დაბრუნების საფუძვლები</h2>
          <p className="rp-section-text">
            პროდუქციის მიღებიდან <strong>3 კალენდარული დღის</strong> განმავლობაში მომხმარებელს
            უფლება აქვს მოითხოვოს მისი უკან დაბრუნება შემდეგ შემთხვევებში:
          </p>
          <ul className="rp-list">
            <li>პროდუქტი არ შეესაბამება შეკვეთას</li>
            <li>პროდუქტი მიწოდებულია დაზიანებულ მდგომარეობაში</li>
            <li>პროდუქტს აქვს ქარხნული წუნი</li>
          </ul>
          <p className="rp-section-text">
            პროდუქტის უკან დაბრუნების შემთხვევაში, მომხმარებლის არჩევანის შესაბამისად,
            წუნდებული პროდუქტის ნაცვლად მოგაწვდით ახალ პროდუქტს ან დავაბრუნებთ გადახდილ
            თანხას დაბრუნების მოთხოვნის დაკმაყოფილებიდან <strong>არაუგვიანეს 10 სამუშაო დღისა</strong>.
          </p>
        </div>

        <div className="rp-section">
          <h2 className="rp-section-title">უარის საფუძვლები</h2>
          <p className="rp-section-text">
            Yourhood უფლებას იტოვებს უარი თქვას თანხის დაბრუნებაზე თუ:
          </p>
          <ul className="rp-list rp-list--warn">
            <li>უკან დაბრუნების მოთხოვნა დაყენებულია ნივთის მიღებიდან 3 დღის შემდგომ</li>
            <li>დაზიანებულია ნივთი</li>
            <li>იკვეთება მომხმარებლის მხრიდან არაკეთილსინდისიერი ქმედება</li>
          </ul>
        </div>

        <div className="rp-section">
          <h2 className="rp-section-title">მოთხოვნის გაგზავნა</h2>
          <p className="rp-section-text">
            უკან დაბრუნების მოთხოვნა გამოგზავნილ უნდა იქნას ელ-ფოსტის მეშვეობით:
          </p>
          <a href="mailto:yourhoodshop@gmail.com" className="rp-email">
            yourhoodshop@gmail.com
          </a>
          <p className="rp-section-text rp-mt">წერილი უნდა მოიცავდეს:</p>
          <ul className="rp-list">
            <li>შეკვეთის ნომერს</li>
            <li>შეკვეთის თარიღს</li>
            <li>შეკვეთის მიღების თარიღს</li>
            <li>დაბრუნების მიზეზს</li>
            <li>შესაძლოა მოთხოვნილ იქნას პროდუქტის სურათი</li>
          </ul>
        </div>

      </div>
    </div>
  )
}

export default Return